/* global Stimulus */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton", "signaturePad", "signatureInput", "form", "documentProcessing"];
  static values = { url: String, types: Array };

  connect() {
    this.toggleSubmitButton();
    this.signaturePadElement = document.querySelector("[data-controller='signature_pad']");
    
    if (this.signaturePadElement) {
      this.signaturePadElement.addEventListener(
        "signature_pad:signed",
        this.toggleSubmitButton.bind(this)
      );
      this.signaturePadElement.addEventListener(
        "signature_pad:unsigned",
        this.toggleSubmitButton.bind(this)
      );

      try {
        const signaturePad = this.getSignaturePad();
        if (signaturePad && typeof signaturePad.show === 'function') {
          signaturePad.show();
        }
      } catch (error) {
        console.log('Signature pad auto-initialized');
      }
    }
    
    this.element.addEventListener("change", this.checkboxChanged.bind(this));

    if (this.hasDocumentProcessingTarget) {
      this.pollData();
    }
  }

  checkboxChanged() {
    this.toggleSubmitButton();
  }

  isConfirmationCheckboxChecked() {
    const checkbox = this.element.querySelector("input[type='checkbox'][name*='documents_confirmation']");
    return checkbox ? checkbox.checked : false;
  }

  toggleSubmitButton() {
    if (!this.hasDocumentProcessingTarget && this.isConfirmationCheckboxChecked() && this.isSigned()) {
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.disabled = true;
    }
  }

  submitSignature() {
    this.getSignaturePad()
      .getSignatureData()
      .then(this.blobToBase64)
      .then((base64String) => {
        if (this.signatureInputTarget) {
          this.signatureInputTarget.value = base64String;
        }
        console.log("submitting form");
        this.formTarget.submit();
      })
      .catch((error) => {
        console.error(error);
        document.getElementById("modal-loading").remove();
      });
  }

  isSigned() {
    try {
      const signaturePad = this.getSignaturePad();
      return signaturePad && signaturePad.isSigned ? signaturePad.isSigned() : false;
    } catch (error) {
      return false;
    }
  }

  blobToBase64(blob) {
    return new Promise((resolve, _reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result.split(",")[1]);
      };
      reader.readAsDataURL(blob);
    });
  }

  getSignaturePad() {
    if (this.signaturePadElement) {
      const signaturePadController = Stimulus.getControllerForElementAndIdentifier(
        this.signaturePadElement,
        "signature_pad"
      );
      if (signaturePadController) {
        return signaturePadController;
      }
    }
    throw new Error("Signature pad not found");
  }

  uploadData(url, formData) {
    return fetch(url, {
      method: "POST",
      body: formData,
    }).then((response) => {
      if (!response.ok) {
        throw new Error("Network error");
      }
      return response.json();
    });
  }

  pollData() {
    setInterval(() => {
      fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.json();
        })
        .then((data) => {
          if (data.documents && this.typesValue.every((type) => Object.keys(data.documents).includes(type))) {
            // const turboFrame = this.element.querySelector("turbo-frame#refresh-documents");
            // const url = new URL(window.location.href);

            // turboFrame.src = `${url.toString()}?t=${Date.now()}`;
            // clearInterval(intervalId);

            location.reload();
          }
        });
    }, 2000);
  }
}
